import React, { Component } from 'react';
import * as _ from 'lodash'

import './index.css';

import State from '../State'
import {getPluralFieldLabel} from '../Helpers'

function Item(props) {
  return <div className="item" onClick={() => {State.action('clearFilter', {field: props.field, value: props.value})}}>
    <div className="item-inner">
      {props.value}
    </div>
    <svg width="24px" height="24px">
      <g transform="translate(12,12)">
        <g transform="rotate(45)">
          <line strokeWidth="2" x1="-5" x2="5" />
          <line strokeWidth="2" y1="-5" y2="5" />
        </g>
      </g>
    </svg>
  </div>
}


function CategoryGroup(props) {
  let items = props.data.values.map(d => <Item field={props.data.field} value={d} key={d} />)
  return <div className="category-group">
          <div className="category-name">Only include {getPluralFieldLabel(props.data.field).toLowerCase()}:</div>
          <div>{items}</div>
        </div>
}

class CategoryFilter extends Component {

  handleFilterSelectedClick() {
    State.action('filterSelected')
  }

  render() {

    let categoryGroups = _.filter(State.filters.categoryMatch, d => d.values.length > 0)
    categoryGroups = categoryGroups.map(d => {
      return <CategoryGroup data={d} key={d.field} />
    })

    let numItemsSelected = _.reduce(State.selectedGroups, (acc, v) => {
      return acc + v.length
    }, 0)


    let activeText = numItemsSelected > 1 ? 'Add ' + numItemsSelected + ' selected items to filter' : 'Add selected item to filter'
    let buttonText = numItemsSelected === 0 ? 'Click any number of campaigns, categories, suppliers or dates then click here to filter' : activeText

    return (
      <div className="category-filter">
        <div className="active-filters">
          {categoryGroups}
        </div>
        <button disabled={numItemsSelected === 0} onClick={this.handleFilterSelectedClick}>{buttonText}</button>
      </div>
    )
  }
}

export default CategoryFilter



// WEBPACK FOOTER //
// ./src/CategoryFilter/index.js